import BaseTool from './base'
import Brush from './brush'
import Erase from './erase'
import Select from './select'

function registerTool() {
  new BaseTool(true)
  new Brush()
  new Erase()
  new Select()
}

export default registerTool
